export type Location = {
  lat: number
  lng: number
}

export type Provider = {
  providerUuid: number
  providerName: string
  providerTypeIds: number[]
  parentIds: number[]
  countryCode: string[]
  lastModified: string
  website?: string
  phone: string
  email?: string
  address: string
  location: Location | null
  distanceInKm: number
  carrotPartner?: boolean
  locationMayVary?: boolean
  networkIds?: number[]
  isVirtual?: boolean
  providerNetworkIds?: string[]
  doulaServices?: string[]
  acceptsDirectPay?: boolean
  carrotCenterOfExcellence?: boolean
  showInMemberApp?: boolean
  originOfficeId?: number
  businessEntityTag?: string[]
  virtualServicesNotAvailableIn?: string[]
  // Only set on the Carrot Clinic sentinel row after the BFF gate passes.
  program?: TelemedicineProgram
}

export type TelemedicineProgram = "fertility" | "menopause" | "mens_fertility"

export type CarrotClinicProvider = Provider & {
  providerUuid: -1
  program: TelemedicineProgram
}

export function isCarrotClinicProvider(p: Provider): p is CarrotClinicProvider {
  return p.providerUuid === -1 && p.program != null
}

export type TypeaheadProvider = {
  uuid: number
  name: string
  address: string
  city: string
}

export type ExtendedProvidersTypeaheadProvider = {
  uuid: number
  name: string
  providerEligibilityStatus: string
}

export type ProviderCount = {
  hasFertilityProviders: boolean
  hasUrologyProviders: boolean
  hasAdoptionProviders: boolean
  hasCryobanksProviders: boolean
  hasLowTProviders: boolean
  hasMenopauseProviders: boolean
  hasGenderAffirmingHormoneTherapyProviders: boolean
  hasDonorAssistedReproductionProviders: boolean
  hasGestationalCarrierProviders: boolean
  hasPelvicFloorTherapyProviders: boolean
  hasDoulasProviders: boolean
  hasProviders: boolean
}
